import * as React from "react";
import pageIds from "~/pageIds";
import type { CategorizedPageHelpRegistration, RenderRegistrationCardProps } from "../../../Registry/pageHelpRegistry";
import { CommonLibraryLifecycleOverview } from "../../CommonComponents/CommonLibraryLifecycleViews";
export const LibraryLifecyclesNewRegistration: CategorizedPageHelpRegistration = {
    page: pageIds.library.lifecyclesCreate,
    renderOverview: (renderProps: RenderRegistrationCardProps) => {
        return <CommonLibraryLifecycleOverview />;
    },
    renderTopics: (renderProps: RenderRegistrationCardProps) => null,
};
